import axios from "axios";
// import store from '../store';
// import { getToken } from '@/utils/auth';

let VUE_APP_API;
if (
  window.location.host.includes("dev") ||
  window.location.host.includes("localhost")
) {
  VUE_APP_API = "https://pipeline.iamcubo.com/";
} else {
  VUE_APP_API = "https://pipeline.iamcubo.com/";
}
//VUE_APP_API = 'https://pipeline.iamcubo.com/';
console.log(VUE_APP_API);

// 創建axios實例
const service = axios.create({
  baseURL: VUE_APP_API, // api 的 base_url
  // 這邊已經預設api路徑
  timeout: 2400000 // 請求超時時間
});
// 讓api設定cookies
service.defaults.withCredentials = true;

// request攔截器
service.interceptors.request.use(
  config => {
    const con = config;
    //console.log('token: ' + localStorage.token)
    if (localStorage.token) {
      // 有token就寫入header
      con.headers.common.token = localStorage.token;
    }
    // console.log("config",config)
    return con;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  }
);

// response 攔截器
service.interceptors.response.use(
  response => {
    /**
     *
     */
    const res = response;
    // console.log('response', res);
    if (localStorage.token) {
      res.headers.token = localStorage.token;
    }
    return res.data;
  },
  error => {
    console.log(error);
    if (error.response.status === 401) {
      localStorage.token = "";
    } else if (error.response.status === 500) {
      return { status: 500 };
    }
    throw error.response.status;
  }
);

export default service;
